import React, { Component, Fragment } from 'react';
import LocaleService from '../Services/LocaleService.js';
import LocaleList from '../Components/Locale/LocaleList.js';
import LocaleCreator from '../Components/Locale/LocaleCreator.js';
import { withApi } from '../Providers/WebServiceProvider.js';
import { withLocales } from '../Providers/LocalesProvider.js';

class EditLocales extends Component
{
	constructor(props) {
		super(props);

		this.localeService = new LocaleService(props.webServiceContext.getApi());
	}

  render () {
  	if (this.props.localesContext.ready) {
	 	  return (
	 	  	<Fragment>
		 	  	<div className="section">
			 	  	<div className="page-section partial">
			 	  		<LocaleCreator 
			 	  			creator={this.localeService.create}
			 	  			adder={this.props.localesContext.adder}
			 	  		/>
			 	  	</div>
			 	  	<div className="page-section partial">
			 	  		<LocaleList 
			 	  			deleter={this.localeService.delete} 
			 	  			updater={this.localeService.update} 
			 	  			duplicator={this.localeService.duplicate} 
			 	  			locales={this.props.localesContext.locales} 
			 	  			key="locale.list"
			 	  		/>
			 	  	</div>
		 	  	</div>
	 	  	</Fragment>
		  );
  	} else {
  		return ('Loading...');
  	}
  }
}

export default withApi(withLocales(EditLocales));


// WEBPACK FOOTER //
// ./src/Pages/EditLocales.js